import { Action, combineReducers, configureStore } from '@reduxjs/toolkit'
import {appSlice} from './slice/appSlice'
import {vacanciesApi} from './api/vacanciesApi'
import {setupListeners} from '@reduxjs/toolkit/query'


const combinedReducer = combineReducers({
	app: appSlice.reducer,
	[vacanciesApi.reducerPath]: vacanciesApi.reducer,
})

export type RootState = ReturnType<typeof combinedReducer>

const rootReducer = (
	state: RootState | undefined,
	action: Action,
): RootState => {
	if (action.type === 'vacancies/api/signOut/fulfilled') {
		state = undefined
	}
	return combinedReducer(state, action)
}

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(vacanciesApi.middleware),
	devTools: process.env.NODE_ENV !== 'production',
})

setupListeners(store.dispatch)

export type AppDispatch = typeof store.dispatch
